import type {CanActivateFn} from "@angular/router";
import {inject} from "@angular/core";
import {AuthService} from "../auth/auth.service";
import {Router} from "@angular/router";
import {filter, first, map} from "rxjs/operators";

export const roleGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);

  return authService.loggedUser.pipe(
    filter(u => !!u),
    first(),
    map(user => {
      if (!route.data?.auth || user.isAdmin)
        return true;
      return router.createUrlTree(["/", "404"]);
    })
  );
};
